<template>
  <header :class="['container-fluid', { scrolled: scrolledDown, home: isHome }]">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="toggle">
            <button :class="['hamburger hamburger--spring', { 'is-active': isMenuOpen }]" type="button" v-on="{ click: isMenuOpen ? hideMenu : showMenu }">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
          <div class="logo">
            <router-link to="/"><img src="../assets/293-kingsway-logo.png" alt="293 The Kingsway" /></router-link>
          </div>
          <nav :class="[ { 'open': isMenuOpen } ]">
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/">Construction</router-link></li>
              <li>
                <a href="http://instagram.com/293kingsway" target="_blank" rel="noopener noreferrer">
                  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Version3.3_White@2x" transform="translate(-1360.000000, -51.000000)" fill="#A1654A">
                        <g id="Group-5" transform="translate(1360.000000, 51.000000)">
                          <path d="M14.4806047,0 L5.51915865,0 C2.47589642,0 0,2.47601472 0,5.51927695 L0,14.480723 C0,17.5241036 2.47589642,20 5.51915865,20 L14.4806047,20 C17.5241036,20 20,17.5239853 20,14.480723 L20,5.51927695 C20,2.47601472 17.5241036,0 14.4806047,0 Z M18.2256214,14.480723 C18.2256214,16.545646 16.545646,18.2255031 14.480723,18.2255031 L5.51915865,18.2255031 C3.45435402,18.2255031 1.77449693,16.545646 1.77449693,14.480723 L1.77449693,5.51927695 C1.77449693,3.45447232 3.45435402,1.77449693 5.51915865,1.77449693 L14.4806047,1.77449693 C16.5455277,1.77449693 18.2256214,3.45447232 18.2256214,5.51927695 L18.2256214,14.480723 L18.2256214,14.480723 Z" id="Shape" fill-rule="nonzero"></path>
                          <path d="M10,4.70588235 C7.08077956,4.70588235 4.70588235,7.08083408 4.70588235,10.0001215 C4.70588235,12.9192875 7.08077956,15.2941176 10,15.2941176 C12.9192204,15.2941176 15.2941176,12.9192875 15.2941176,10.0001215 C15.2941176,7.08083408 12.9192204,4.70588235 10,4.70588235 Z M10,13.4710365 C8.08605792,13.4710365 6.52880007,11.913986 6.52880007,10 C6.52880007,8.08589245 8.08593639,6.52872039 10,6.52872039 C11.9140636,6.52872039 13.4711999,8.08589245 13.4711999,10 C13.4711999,11.913986 11.9139421,13.4710365 10,13.4710365 Z" id="Shape" fill-rule="nonzero"></path>
                          <path d="M15.2941176,3.52941176 C14.9850267,3.52941176 14.6813904,3.65454545 14.4631016,3.87379679 C14.2437433,4.09197861 14.1176471,4.39572193 14.1176471,4.70588235 C14.1176471,5.01508021 14.2438503,5.31871658 14.4631016,5.53796791 C14.6812834,5.75614973 14.9850267,5.88235294 15.2941176,5.88235294 C15.6042781,5.88235294 15.9069519,5.75614973 16.1262032,5.53796791 C16.3454545,5.31871658 16.4705882,5.01497326 16.4705882,4.70588235 C16.4705882,4.39572193 16.3454545,4.09197861 16.1262032,3.87379679 C15.9080214,3.65454545 15.6042781,3.52941176 15.2941176,3.52941176 Z" id="Path"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      scrolledDown: false,
      isMenuOpen: false,
      isHome: true
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        // on route change, store whether it's the homepage or not
        this.isHome = to.name === 'home'

        // hide menu on page change
        this.isMenuOpen = false
      }
    },
  },
  methods: {
    hideMenu: function() {
      this.isMenuOpen = false
    },
    showMenu: function() {
      this.isMenuOpen = true
    }
  },
  mounted: function () {
    this.$nextTick(function() {
      window.addEventListener('scroll', () => {
        this.scrolledDown = window.pageYOffset > 50
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

// import hamburger menu
@import '../stylesheets/hamburgers/hamburgers';

header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: white;
  transition: background-color 250ms;

  &.container-fluid {
    @media all and (max-width: $smallMax) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  div.col {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
    transition: padding-top 250ms, padding-bottom 250ms;

    div.toggle {
      display: none;
      margin: 0 15px 0 0;
      position: relative;
      z-index: 10;

      @media all and (max-width: $smallMax) {
        display: block;
      }

      button.hamburger {
        padding: 5px 5px;
        transform: scale(0.66);

        &:active,
        &:focus {
          outline: none;
        }
      }

      span.hamburger-box {
        span.hamburger-inner,
        span.hamburger-inner::after,
        span.hamburger-inner::before {
          border-radius: 0;
          height: 3px;
        }

        span.hamburger-inner::before {
          // top: 8px;
        }

        span.hamburger-inner::after {
          // top: 16px;
        }
      }
    }

    div.logo {
      margin-right: auto;
      position: relative;
      z-index: 10;
      transition: opacity 250ms;
      opacity: 1;

      img {
        width: 62px;
        height: auto;
      }
    }

    nav {
      @media all and (max-width: $smallMax) {
        display: none;
        background-color: transparent;
        transition: padding-top 250ms, background-color 250ms;

        &.open {
          display: block;
          background-color: white;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          padding-top: 100px;
          box-shadow: 0 2px 30px rgba(black, 0.5);

          ul {
            flex-direction: column;
            align-items: center;
            width: 100%;

            li {
              width: 100%;
              text-align: center;
              padding: 10px 0;

              &:first-child {
                padding-top: 20px;
                border-top: 1px solid #e9e9e9;
              }

              a {
                color: black;
                font-size: 20px;

                svg {
                  path {
                    fill: $red;
                  }
                }
              }
            }
          }
        }
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;

        li {
          padding: 0 21px;

          &:first-child {
            display: none;
            padding-left: 0;

            @media all and (max-width: $smallMax) {
              display: list-item;
            }
          }

          &:last-child {
            padding-right: 0;
          }

          a {
            font-weight: 700;
            font-size: 14px;
            color: black;
            padding-bottom: 4px;

            &.router-link-active,
            &:hover {
              border-bottom: 4px solid $red;
              text-decoration: none;
            }
          }

          &:last-child {
            a {
              &.router-link-active,
              &:hover {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
